import { render, staticRenderFns } from "./editInfo.vue?vue&type=template&id=1c6f4dc2&scoped=true&lang=html"
import script from "./editInfo.vue?vue&type=script&lang=js"
export * from "./editInfo.vue?vue&type=script&lang=js"
import style0 from "./editInfo.vue?vue&type=style&index=0&id=1c6f4dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f4dc2",
  null
  
)

export default component.exports